/**
 * Trunclate text
 * @param {int} n - number of characters
 * @param {string} end - trunclated text suffix 
 */
export const trunclate = (text='', max=100, end = ' ...') => {
    if(!text) return '';
    if (text.length <= max) return text;
    let subString = text.substr(0, max-1);
    return subString.substr(0, subString.lastIndexOf(' ')) + end;
}

export const currentLanguage = () => {
    return window.location.pathname.substr(1, 3) === 'en' ? 'en' : 'no';
}

export const redirectHome = () => {
    const path = currentLanguage() === 'no' ? '/' : '/en';
    window.location.replace(path);
}

export const redirect404 = () => {
    const path = currentLanguage() === 'no' ? '/404' : '/en/404';
    window.location.replace(path);
}

export const urlEncode = str => {

    //remove line breaks
    str = str.replace(/\r?\n|\r/g, ' ');

    // strip tags
    let text;
    const div = document.createElement('div');
    div.innerHTML = str;
    text = div.textContent || div.innerText || '';

    // encode url
    return encodeURIComponent(text)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+');
}

export const stripTags = str => {
    const div = document.createElement('div');
    div.innerHTML = str;
    return  div.textContent || div.innerText || '';
}

export const removeLinebreaks = str => {
    return str.replace(/\r?\n|\r/g, ' ');
}

export const isIOSSafari = () => {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    return iOS && webkit && !ua.match(/CriOS/i);
}

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
 export const isIE = () => {
    var ua = window.navigator.userAgent;
  
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
  
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
  
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
  
    // other browser
    return false;
  }


// WEBPACK FOOTER //
// ./src/helpers.js